import { roomColor, fmtFt } from "@/lib/walls";

export const RoomSchedule = ({ plan, selectedId, onSelect, hideDims = false }) => (
  <div data-testid="room-schedule">
    <table className="w-full text-sm">
      <thead>
        <tr className="font-mono text-[10px] uppercase tracking-widest text-[var(--muted)] border-b border-[var(--line)]">
          <th className="text-left py-2 font-normal">Room</th>
          <th className="text-right py-2 font-normal">Size</th>
          <th className="text-right py-2 font-normal">SF</th>
        </tr>
      </thead>
      {plan.floors.map((f, fi) => (
      <tbody key={fi} data-testid={`schedule-floor-${fi}`}>
        {plan.floors.length > 1 && (
          <tr className="font-mono text-[10px] uppercase tracking-widest text-[var(--amber)]">
            <td className="pt-4 pb-1">{f.name}</td><td /><td className="pt-4 pb-1 text-right">{hideDims ? "—" : Math.round(f.area)}</td>
          </tr>
        )}
        {f.rooms.map((r) => (
          <tr key={r.id} onClick={() => onSelect?.(r.id)} data-testid={`schedule-row-${r.id}`}
            className={`border-b border-[var(--line)]/60 cursor-pointer transition-colors ${r.id === selectedId ? "bg-[var(--cyan)]/10" : "hover:bg-white/[0.03]"}`}>
            <td className="py-2.5 pr-2">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 shrink-0" style={{ background: roomColor(r.type) }} />
                <span className="truncate">{r.name}</span>
              </div>
              <div className="pl-4 text-[11px] text-[var(--muted)]">{r.flooring}</div>
            </td>
            <td className="py-2.5 text-right font-mono text-xs text-[var(--muted)] whitespace-nowrap">{hideDims ? "locked" : `${fmtFt(r.w)}×${fmtFt(r.h)}`}</td>
            <td className="py-2.5 text-right font-mono text-xs">{hideDims ? "—" : Math.round(r.area)}</td>
          </tr>
        ))}
      </tbody>
      ))}
      <tfoot>
        <tr className="font-mono text-xs">
          <td className="pt-3 uppercase tracking-widest text-[var(--muted)] text-[10px]">Total</td>
          <td />
          <td className="pt-3 text-right text-[var(--cyan)]" data-testid="schedule-total-area">{Math.round(plan.total_area)}</td>
        </tr>
      </tfoot>
    </table>
  </div>
);
